var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("steps-form", {
        attrs: { editState: _vm.editState },
        on: { next_step: _vm.gotoNewTask, list: _vm.gotoList },
        model: {
          value: _vm.item,
          callback: function ($$v) {
            _vm.item = $$v
          },
          expression: "item",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }